import { render, staticRenderFns } from "./PscAttachment.vue?vue&type=template&id=cd5d4b38&scoped=true&"
import script from "./PscAttachment.vue?vue&type=script&lang=js&"
export * from "./PscAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5d4b38",
  null
  
)

export default component.exports